import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { navLinks, siteInfo } from '@/mocks/site';
import { liveSessions } from '@/mocks/lives';
import { useScrolled } from '@/hooks/useScrolled';
import { todayLabel, todayWeekday } from '@/utils/time';

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const scrolled = useScrolled(16);
  const liveCount = liveSessions.filter((item) => item.status === 'live').length;

  return (
    <>
      <div className="w-full bg-primary-950 text-primary-100">
        <div className="container-page flex h-9 items-center justify-between text-xs">
          <div className="flex items-center gap-2 truncate">
            <span className="w-4 h-4 flex items-center justify-center">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-400 animate-pulse" />
            </span>
            <span className="truncate">
              当前正在直播 <strong className="font-semibold text-primary-50">{liveCount}</strong> 场 · 排期每 15 分钟校对一次
            </span>
          </div>
          <span className="hidden sm:block text-primary-200">
            今日 {todayLabel()} {todayWeekday()}
          </span>
        </div>
      </div>

      <header
        className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
          scrolled
            ? 'border-background-200 bg-background-50/95 backdrop-blur'
            : 'border-transparent bg-background-50/80 backdrop-blur-sm'
        }`}
      >
        <div className="container-page flex h-16 items-center justify-between gap-4 md:h-[72px]">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-lg font-bold text-background-50">
              爆
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold text-foreground-950">{siteInfo.name}</span>
              <span className="mt-1 hidden text-[11px] text-foreground-500 sm:block">{siteInfo.slogan}</span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
            {navLinks.map((link) => (
              <NavLink
                key={link.path}
                to={link.path}
                end={link.path === '/'}
                className={({ isActive }) =>
                  `rounded-md px-3.5 py-2 text-sm transition-colors duration-200 ${
                    isActive
                      ? 'bg-primary-100 font-semibold text-primary-800'
                      : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden items-center gap-2 md:flex">
            <Link
              to="/schedule"
              className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3.5 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-calendar-schedule-line" aria-hidden="true" />
              </span>
              查看排期
            </Link>
            <Link
              to="/schedule#subscribe"
              className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-notification-3-line" aria-hidden="true" />
              </span>
              开启提醒
            </Link>
          </div>

          <button
            type="button"
            onClick={() => setOpen((prev) => !prev)}
            aria-label={open ? '关闭菜单' : '打开菜单'}
            aria-expanded={open}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-2-line text-xl'} aria-hidden="true" />
          </button>
        </div>

        {open && (
          <div className="border-t border-background-200 bg-background-50 md:hidden">
            <nav className="container-page flex flex-col py-3" aria-label="移动端导航">
              {navLinks.map((link) => (
                <NavLink
                  key={link.path}
                  to={link.path}
                  end={link.path === '/'}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `flex items-center justify-between rounded-md px-3 py-3 text-sm transition-colors ${
                      isActive
                        ? 'bg-primary-100 font-semibold text-primary-800'
                        : 'text-foreground-700 hover:bg-background-100'
                    }`
                  }
                >
                  {link.label}
                  <span className="w-4 h-4 flex items-center justify-center text-foreground-400">
                    <i className="ri-arrow-right-s-line" aria-hidden="true" />
                  </span>
                </NavLink>
              ))}
              <Link
                to="/schedule#subscribe"
                onClick={() => setOpen(false)}
                className="mt-3 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-medium text-background-50"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-notification-3-line" aria-hidden="true" />
                </span>
                开启直播预告提醒
              </Link>
            </nav>
          </div>
        )}
      </header>
    </>
  );
}